import styled from 'styled-components';

const RadioButtonWrapper = styled.div`
  margin: 0 8px 0 0;
`;

export default RadioButtonWrapper;
